import styled from 'styled-components';

export const SlideContainer = styled.div`
  position: fixed;
  top: ${({ top }) => (typeof top === 'number' ? `${top}px` : top)};
  right: ${({ right }) => (typeof right === 'number' ? `${right}px` : right)};
  left: ${({ left }) => (typeof left === 'number' ? `${left}px` : left)};
  z-index: ${({ zIndex }) => zIndex || 201};
  height: 100vh;
  width: ${({ $slideDistance }) => $slideDistance};
  background: ${({ theme }) => theme.white || '#ffffff'};
  box-shadow: ${({ $isOpen }) =>
    $isOpen ? '0 4px 20px rgba(0, 0, 0, 0.15)' : 'none'};
  
  ${({ $shouldAnimateDesktop }) =>
    $shouldAnimateDesktop === false &&
    ` 
      display: contents;
  `}
  
  transform: ${({ $isOpen, $slideDistance, $slideFromLeft }) =>
    $isOpen
      ? `translateX(${$slideFromLeft ? $slideDistance || '100%' : '0px'})`
      : `translateX(${$slideFromLeft ? '0px' : $slideDistance || '100%'})`};
  
  transition: transform 250ms ease-out, box-shadow 250ms ease-out;
`;

export const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const DialogHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  background: ${({ theme }) => theme.white || '#ffffff'};
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  margin-right: 12px;
  border-radius: 4px;
  color: ${({ theme }) => theme.textColor || '#333333'};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 200ms ease;

  &:hover {
    background-color: ${({ theme }) => theme.hoverBackground || '#f5f5f5'};
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.focusColor || '#007bff'};
    outline-offset: 2px;
  }
`;

export const DialogBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 10px 48px;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.scrollbarTrack || '#f1f1f1'};
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.scrollbarThumb || '#c1c1c1'};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.scrollbarThumbHover || '#a8a8a8'};
  }
`;
